module.exports = __webpack_public_path__ + "static/media/pdf.17fb6010.svg";


//////////////////
// WEBPACK FOOTER
// ./src/UI/FilenameWithIcon/pdf.svg
// module id = 726
// module chunks = 3